import React, { PropTypes, Component } from 'react';
import feedbackGood from 'assets/images/icons/icon_feedback_good.svg';
import feedbackBad from 'assets/images/icons/icon_feedback_bad.svg';
import feedbackMeh from 'assets/images/icons/icon_feedback_meh.svg';
import menu from 'assets/images/icons/icon_menu.svg';
import filter from 'assets/images/icons/icon_filter.svg';
import navMenu from 'assets/images/icons/icon_nav-menu.svg';
import comments from 'assets/images/icons/icon_comments.svg';
import versions from 'assets/images/icons/icon_versions.svg';
import close from 'assets/images/icons/icon_close.svg';
import arrowRight from 'assets/images/icons/icon_arrow_right.svg';
import arrowLeft from 'assets/images/icons/icon_arrow_left.svg';
import notifications from 'assets/images/icons/icon_notifications.svg';
import send from 'assets/images/icons/icon_send.svg';
import zoomIn from 'assets/images/icons/icon_zoom-in.svg';
import zoomOut from 'assets/images/icons/icon_zoom-out.svg';
import fullscreen from 'assets/images/icons/icon_fullscreen.svg';
import trash from 'assets/images/icons/icon_trash.svg';
import download from 'assets/images/icons/icon_download.svg';

/**
 * @module common/components/svg_icon
 */

const Icon = (props) => {
    
    var svg;
    
    switch(props.icon) {
      default:
        return <i className="icon"></i>;
        
      case "arrowRight":
        svg = arrowRight;
        break;
      
      case "arrowLeft":
        svg = arrowLeft;
        break;
        
      case "close":
        svg = close;
        break;
        
      case "comments":
        svg = comments;
        break;
      
      case "feedback-good":
        svg = feedbackGood;
        break;
        
      case "feedback-bad":
        svg = feedbackBad;
        break;
      
      case "feedback-meh":
        svg = feedbackMeh;
        break;
      
      case "filter":
        svg = filter;
        break;
        
      case "fullscreen":
        svg = fullscreen;
        break;
        
      case "menu":
        svg = menu;
        break;
      
      case "nav-menu":
        svg = navMenu;
        break;
      
      case "notifications":
        svg = notifications;
        break;
      
      case "send":
        svg = send;
        break;
        
      case "versions":
        svg = versions;
        break;
      
      case "zoomIn":
        svg = zoomIn;
        break;
        
      case "zoomOut":
        svg = zoomOut;
        break;
        
      case "trash":
        svg = trash;
        break;
        
      case "download":
        svg = download;
        break;
    }
    
    return <i className={props.className} dangerouslySetInnerHTML={{__html: svg}} aria-hidden="true"></i>
}

/**
 * PropTypes.
 *
 * @property {string} icon - the svg icon to display
 * @property {string} extraClasses - additional class names to modify icon
 *
 */
 
Icon.propTypes = {
  icon: PropTypes.string,
  extraClasses: PropTypes.string,
};


export default Icon;


// WEBPACK FOOTER //
// ./common/components/svg_icon.jsx